import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import { RECOMMEND_LIST } from '../index.js';
export default {
  data() {
    return {
      recommendList: RECOMMEND_LIST,
      mySwiper1: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.mySwiper1) {
        this.mySwiper1.destroy();
      }
      this.mySwiper1 = new Swiper('.swiper-containers', {
        observer: true,
        // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        // 修改swiper的父元素时，自动初始化swiper
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.home-go-right',
          prevEl: '.home-go-left',
          hideOnClick: true
        }
      });
    });
  }
};